'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cwUi = require('cw-ui');

var _AutomationName = require('../../../services/AutomationName');

var _AutomationName2 = _interopRequireDefault(_AutomationName);

var _ClickTracker = require('../../../services/ClickTracker');

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

// https://github.com/ReactTraining/react-router/blob/master/packages/react-router-dom/docs/api/Link.md

var ButtonLink = function (_React$Component) {
  (0, _inherits3.default)(ButtonLink, _React$Component);

  function ButtonLink() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ButtonLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ButtonLink.__proto__ || (0, _getPrototypeOf2.default)(ButtonLink)).call.apply(_ref, [this].concat(args))), _this), _this.getAutomationName = function () {
      return _AutomationName2.default.get('btn', _this.props.automationName);
    }, _this.handleClick = function (event) {
      if (event.type === 'keydown' && event.key === 'Enter' || // allow enter key down bubbled from cwbutton's handlekeydown
      !event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
        event.preventDefault();

        (0, _ClickTracker.addClickTrack)(_this.getAutomationName());

        if (_this.props.onClick) {
          _this.props.onClick(event);
        }

        var history = _this.context.router.history;
        var _this$props = _this.props,
            replace = _this$props.replace,
            to = _this$props.to;


        if (replace) {
          history.replace(to);
        } else {
          history.push(to);
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ButtonLink, [{
    key: 'render',
    value: function render() {
      (0, _invariant2.default)(this.context.router, "You should not use <Link> outside a <Router>");

      (0, _invariant2.default)(this.props.to !== undefined, 'You must specify the "to" property');

      return _react2.default.createElement(_cwUi.CwButton, (0, _assign2.default)({}, this.props, {
        cwId: this.getAutomationName(),
        onClick: this.handleClick
      }));
    }
  }]);
  return ButtonLink;
}(_react2.default.Component);

ButtonLink.propTypes = (0, _assign2.default)({
  /**
   * Element id used as selection and search for automation testing
   */
  automationName: _propTypes2.default.string.isRequired,
  /**
   * When true, clicking the link will replace the current entry in the history stack instead of adding a new one
   */
  replace: _propTypes2.default.bool,
  /**
   * A string representation of the location to link to, created by concatenating the location's pathname, search, and hash properties
   */
  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
}, _cwUi.CwButton.propTypes);

ButtonLink.defaultProps = {
  replace: false
};

ButtonLink.contextTypes = {
  router: _propTypes2.default.shape({
    history: _propTypes2.default.shape({
      push: _propTypes2.default.func.isRequired,
      replace: _propTypes2.default.func.isRequired,
      createHref: _propTypes2.default.func.isRequired
    }).isRequired
  }).isRequired
};

exports.default = ButtonLink;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/managewidgets/components/button/ButtonLink.js
// module id = 766
// module chunks = 10